module.exports = __webpack_public_path__ + "img/image2.dd68a9c1.png";